// web/src/components/consent/ConsentCheckbox.tsx
//
// Reusable labelled checkbox row for consent capture. Never pre-ticked by a
// caller that passes checked={false} initially — that's enforced by the
// callers (ConsentGate), not this component, since this component itself is
// just a controlled row and has no opinion on default state.
import type { ReactNode } from 'react';

interface ConsentCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  required?: boolean;
}

export function ConsentCheckbox({ id, checked, onChange, label, required }: ConsentCheckboxProps) {
  return (
    <label htmlFor={id} className="flex items-start gap-3 cursor-pointer select-none text-left">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
        className="w-5 h-5 mt-0.5 shrink-0 accent-coral"
      />
      <span className="font-grotesk font-medium text-[13px] text-body-grey leading-relaxed">{label}</span>
    </label>
  );
}

export default ConsentCheckbox;
